import React, { useState, useEffect } from "react";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Line,
    Area,
    ComposedChart,
} from "recharts";
const monthMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
  };
const EPByMonth = () => {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        fetch("https://malaria-api.ddc-malaria.org/mhealth/getChartOverallEPToday/fs_year")
            .then((response) => response.json())
            .then((data) => {
                const transformedData = Object.entries(
                    data.overall_ep_status_by_month_fiscal
                ).map(([monthKey, monthData]) => {
                    const { year_month, total_ep_detail } = monthData;
                    //const monthYear = year_month.slice(4) + ", " + year_month.slice(0, 4);
                    const monthYear = monthMap[year_month.slice(4)];

                    const {
                        total_ep_site,
                        total_ep_routine,
                        total_ep_source,
                    } = total_ep_detail;

                    

                    return {
                        month: monthYear,
                        Site: parseInt(total_ep_site, 10),
                        Routine: parseInt(total_ep_routine, 10),
                        Source: parseInt(total_ep_source, 10), // Assuming 'Active' corresponds to 'total_cancel'
                    };
                });

                setChartData(transformedData);
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, []);

    return (
        <div className="plan-status-by-month">
            <h3>Overall Commodities by Month</h3>
            <ResponsiveContainer width="100%" height={300}>
            <ComposedChart
          width={500}
          height={300}
          data={chartData}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
            <defs>
                <linearGradient id="colorSite" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                </linearGradient>
                <linearGradient id="colorSource" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                </linearGradient>
                <linearGradient id="colorRoutine" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#ffc658" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#ffc658" stopOpacity={0}/>
                </linearGradient>
            </defs>
          <XAxis dataKey="month" tick={{ fontSize: 14 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip />
          <Area type="monotone" dataKey="Source" stackId="1" stroke="#82ca9d" fill="url(#colorSource)" strokeDasharray="5 5"  />
          <Line type="monotone" dataKey="Source" stroke="#82ca9d" strokeWidth={0} dot={true}     label={{ position: 'top', fontSize: 12 }} />
          <Area type="monotone" dataKey="Routine" stackId="2" stroke="#ffc658" fill="url(#colorRoutine)" strokeDasharray="5 5" />
          <Line type="monotone" dataKey="Routine" stroke="#ffc658" strokeWidth={0} dot={true}     label={{ position: 'top', fontSize: 12 }} />
          <Area type="monotone" dataKey="Site" stackId="3" stroke="#8884d8" fill="url(#colorSite)" strokeDasharray="5 5" />
          <Line type="monotone" dataKey="Site" stroke="#8884d8" strokeWidth={0} dot={true}     label={{ position: 'top' , fontSize: 12}} />
          
          
          
        </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
};

export default EPByMonth ;

